import { RESET_STATE, FETCH_DSO_LIST, MAP_DSO, UPDATE_DSO_CONFIG, ACTION_LOGOUT_INITIATED } from '../actions/types';

const initialState = {
	dsoItems: {
		totalResults: 0,
		records: [],
	},
};

export default function (state = initialState, action) {
	let dsoItems;
	switch (action.type) {
		case RESET_STATE:
			return initialState;

		case FETCH_DSO_LIST:
			return {
				...state,
				dsoItems: action.payload,
			};

		case MAP_DSO:
			dsoItems = state.dsoItems.records;
			dsoItems.forEach((item, index) => {
				if (item._id === action.payload._id) {
					dsoItems[index] = action.payload;
				}
			});
			return {
				...state,
				dsoItems: {
					totalResults: state.dsoItems.totalResults,
					records: dsoItems,
				},
			};

		case UPDATE_DSO_CONFIG:
			dsoItems = state.dsoItems.records;
			dsoItems.forEach((item, index) => {
				if (item._id === action.payload._id) {
					dsoItems[index] = action.payload;
				}
			});
			return {
				...state,
				dsoItems: {
					totalResults: state.dsoItems.totalResults,
					records: dsoItems,
				},
			};

		case ACTION_LOGOUT_INITIATED:
			return initialState;	

		default:
			return state;
	}
}
